import { sponsorPost, sponsorGet, sponsorPut } from "@/plugins/request";

export default {
  login: (data) =>
    sponsorPost("/login", data, {
      headers: { isToken: false, repeatSubmit: false },
    }),
  getCodeImg: () =>
    sponsorGet(
      "/captchaImage",
      {},
      { headers: { isToken: false }, timeout: 20000 }
    ),
  getInfo: () => sponsorGet("/getInfo"),
  logout: () => sponsorPost("/logout"),
  sendResetCode: (data) =>
    sponsorPost("/open/loginPw/sendCode", data, {
      headers: { isToken: false },
    }),
  resetPasswordByCode: (data) =>
    sponsorPut("/open/loginPw/resetPasswordWithCode", data, {
      headers: { isToken: false },
    }),
};
